import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    buttonGoogle: {
        height: '40px',
        width: '240px',
        borderRadius: '1px',
        backgroundColor: '#4285F4',
        color: 'white',
        justifyContent: 'space-between',
        padding: 0,
        margin: 5,
        '&:hover': {
            backgroundColor: '#4285F4',
            color: 'white',
            boxShadow: '0 0 3px 3px lightgrey',
        }
    },
    buttonMoodle: {
        height: '40px',
        width: '240px',
        borderRadius: '1px',
        backgroundColor: '#F48020',
        color: 'white',
        justifyContent: 'space-between',
        padding: 0,
        margin: 5,
        '&:hover': {
            backgroundColor: '#F48020',
            color: 'white',
            boxShadow: '0 0 3px 3px lightgrey',
        }
    },
    buttonText: {
        width: '200px',
        textTransform: 'none',
        fontSize: '16px',
        textAlign: 'center'
    },
    iconContainer: {
        width: '38px',
        height: '38px',
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        width: '30px',
        height: '30px',
    }
}));

export { useStyles };